import { ChevronRight } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useSaveDemandRequest } from '../../common/useSaveDemandRequest';
import { I18nNamespace } from '~/common/types';
import { DialogActionsLayout } from '~/components/DialogWizard/components/DialogActionsLayout/DialogActionsLayout';
import { TooltipTypography } from '~/components/TooltipTypography/TooltipTypography';
import { useWizardFormControls } from '~/components/WizardState/hooks/useWizardFormControls/useWizardFormControls';

export const RefineQuoteDetailsStepActions = () => {
  const { submit, next, cancel, disabled } = useWizardFormControls(useSaveDemandRequest());

  const { t: tGeneralActions } = useTranslation(I18nNamespace.common, { keyPrefix: 'DialogWizard.general.actions' });
  const { t } = useTranslation(I18nNamespace.demand, {
    keyPrefix: 'NegotiationCaseCreate.wizard.RefineQuoteDetails.actions',
  });

  return (
    <DialogActionsLayout
      left={<Button onClick={cancel}>{tGeneralActions('cancel')}</Button>}
      right={
        <>
          <TooltipTypography placement="top" arrow title={t('saveDemandRequest.tooltip')}>
            <span>
              <Button disabled={disabled} onClick={submit}>
                {t('saveDemandRequest.label')}
              </Button>
            </span>
          </TooltipTypography>
          <Button disabled={disabled} variant="contained" color="primary" endIcon={<ChevronRight />} onClick={next}>
            {t('createNegotiationCase')}
          </Button>
        </>
      }
    ></DialogActionsLayout>
  );
};
